// IM-XPR-002 — /objetivos/:key: cada objetivo na sua tela de fluxo. Chave desconhecida = página não encontrada.
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { objectiveOf } from '@intelimove/contracts';
import { NotFound } from '../pages/NotFound';
import { CompetitorsObjective } from './CompetitorsObjective';
import { OffersObjective } from './OtherObjectives';
import { PlanObjective } from './PlanObjective';
import { TrackObjective } from './TrackObjective';
import { TargetsObjective } from './TargetsJourney';

export function ObjectiveDetail() {
  const { key = '' } = useParams();
  const def = objectiveOf(key);
  useEffect(() => { if (def) document.title = `${def.title} · InteliMove`; }, [def]);
  if (!def) return <NotFound />;
  switch (def.key) {
    case 'concorrentes': return <CompetitorsObjective />;
    case 'ofertas': return <OffersObjective />;
    case 'empresas': return <TargetsObjective />;
    case 'planejar': return <PlanObjective />;
    case 'acompanhar-plano': return <TrackObjective />;
  }
}
